<template>
  <detail-layout-two-columns-no-fixed-collapsible class="layout-list-two-columns" 
    :to-edge="toEdge" :custom-left="customLeft" :custom-right="customRight" :collapsed="collapsed" @update:collapsed="$emit('update:collapsed', $event)">
    <template slot="header">
      <slot name="header" />
    </template>
    <template slot="LeftCol">
      <main class="content h-full flex flex-col flex-auto">
        <div class="table-tools px-4 lg:px-10 w-full sticky top-0 bg-white dark:bg-darkblue-900">
          <div class="flex flex-col lg:flex-row justify-between items-center space-y-3 lg:space-y-0">
            <slot name="table-core" />
          </div>
          <slot name="table-tags" />
        </div>
        <div :class="{ 'table-actions-visible': tableTools }" class="w-full overflow-hidden flex-grow table-kendo">
          <!-- pb-11 lg:pb-15 <div class="w-full lg:px-9"> aqui estaba antes tab-component</div> -->
          <slot name="table-component" />
        </div>
      </main>
    </template>
    <template slot='RightCol'>
      <slot name="RightCol"/>
    </template>
    <template slot='layout-extend'>
      <slot name="layout-extend" />
    </template>
  </detail-layout-two-columns-no-fixed-collapsible>
</template>
<script>
import DetailLayoutTwoColumnsNoFixedCollapsible from '@/components/layout/DetailLayoutTwoColumnsNoFixedCollapsible.vue'

export default {
  name: 'layout-list-two-columns-no-fixed-collapsible',
  components: {
    DetailLayoutTwoColumnsNoFixedCollapsible
  },
  props: {
    toEdge: {
      type: Boolean,
      default: false
    },
    tableTools: {
      type: Boolean,
      default: false
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    customLeft: {
      type: [Array, Object, String],
      default: ''
    },
    customRight: {
      type: [Array, Object, String],
      default: ''
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mainHeight: 'auto',
      resizeObserver: null
    }
  },
  mounted () {
    const mainElement = this.$refs.main
    if (mainElement) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateMainHeight()
      })
      this.resizeObserver.observe(mainElement)
    }
  },
  methods: {
    updateMainHeight: function () {
      const mainElement = this.$refs.main
      if (mainElement) {
        this.mainHeight = getComputedStyle(mainElement).height
      }
    }
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
}
</script>
<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
  @include breakpoint(lg) {
    width: calc(100% - 18.125rem);
  }
}

.aside-is-collapsed {
  .content-wrapper {
    @include breakpoint(lg) {
      width: calc(100% - 4.5rem);
    }
  }
}


</style>
<style>
@property --left-height {
  syntax: "<length-percentage>|auto";
  inherits: true;
  initial-value: auto;
}
@media (width < 1300px){
  .column-container{
    flex-direction: column;
  }
}
</style>
